import { TableRow, Typography, Box } from '@mui/material';
import { RowTableCell } from '../../../common/components';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NoDataSkeleton = ({
  colSpan = 10,
  message = 'No hay datos disponibles',
  showSubtitle = true,
}) => {
  return (
    <TableRow>
      <RowTableCell
        sx={{
          textAlign: 'center',
          padding: '60px 20px',
          border: 'none',
        }}
        colSpan={colSpan}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.6,
            gap: 2,
          }}
        >
          <SearchOffIcon
            sx={{
              fontSize: { xs: '48px', md: '64px' },
              color: 'text.secondary',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '16px', md: '18px' },
              color: 'text.secondary',
              fontWeight: 'medium',
            }}
          >
            {message}
          </Typography>
          {showSubtitle && (
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: '12px', md: '14px' },
                color: 'text.disabled',
                maxWidth: '300px',
                textAlign: 'center',
              }}
            >
              Intenta ajustar los filtros o verifica que existan registros para mostrar.
            </Typography>
          )}
        </Box>
      </RowTableCell>
    </TableRow>
  );
};

export default NoDataSkeleton;
